import React from 'react';
import { Box, ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import { HiOutlineArrowTopRightOnSquare as ExternalLinkIcon } from 'react-icons/hi2';
import { fonts, spacing, borderRadius } from '../../constants';

/**
 * SidebarExternalLink Component
 * Displays external link to AAI Platform
 * 
 * @param {boolean} isCollapsed - Whether the sidebar is collapsed
 * @param {string} url - External URL to link to
 * @param {string} label - Link label text
 */
const SidebarExternalLink = ({ isCollapsed, url, label = 'AAI Platform' }) => {
  return (
    <Box
      sx={{
        borderTop: `1px solid rgba(255, 255, 255, 0.1)`,
        px: isCollapsed ? spacing.xs : spacing.sm,
        py: spacing.xs,
        backgroundColor: 'transparent',
      }}
    >
      <Tooltip title={isCollapsed ? label : ''} placement="right">
        <ListItemButton
          component="a"
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            borderRadius: borderRadius.sm,
            minHeight: 36,
            height: 36,
            justifyContent: isCollapsed ? 'center' : 'flex-start',
            px: isCollapsed ? spacing.xs : spacing.sm,
            py: 0,
            backgroundColor: 'transparent',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.05)',
              color: 'rgba(255, 255, 255, 0.9)',
              '& .MuiListItemIcon-root': {
                color: 'rgba(255, 255, 255, 0.9)',
              },
              '& .MuiListItemText-primary': {
                color: 'rgba(255, 255, 255, 0.9)',
              },
            },
            transition: 'all 0.2s ease',
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: isCollapsed ? 0 : 28,
              color: 'rgba(255, 255, 255, 0.7)',
              justifyContent: 'center',
              display: 'flex',
              alignItems: 'center',
              '& svg': {
                fontSize: '20px',
                width: '20px',
                height: '20px',
                strokeWidth: 1.5,
                transition: 'all 0.2s ease',
              },
            }}
          >
            <ExternalLinkIcon />
          </ListItemIcon>
          {!isCollapsed && (
            <ListItemText
              primary={label}
              primaryTypographyProps={{
                fontSize: '13.5px',
                fontWeight: fonts.weightSemiBold,
                color: 'rgba(255, 255, 255, 0.85)',
                letterSpacing: '-0.01em',
                lineHeight: 1.3,
              }}
            />
          )}
        </ListItemButton>
      </Tooltip>
    </Box>
  );
};

export default SidebarExternalLink;
